

import React, { useState } from 'react';
export default function Partners() {
  return (
    <section className="border-t border-slate-100 dark:border-slate-800">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <p className="text-center text-slate-600 dark:text-slate-300">
          Upskilled learners hired by 750+ partners
        </p>
        <div className="mt-4 flex flex-wrap items-center justify-center gap-3">
          {['TechNova','DataWorks','Cloudify','GitHubverse','BehanceLab'].map(l => (
            <span key={l} className="logo-pill">{l}</span>
                   ))}
        </div>
      </div>
    </section>
  );
}
